export class Param {
    id: number;
    key: string;
    name: string;
    workflowFormId: number;
    value: string;
}
